import React from "react";

import AddIcon from "@mui/icons-material/Add";
import { Box, Button, List, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import IngredientsListItem from "./IngredientListItem";
import IngredientSearchPanel from "./IngredientSearchPanel";
import { useRecipe } from "../store/RecipeStore";

const useStyles = makeStyles()({
  list: {
    flex: 1,
    height: "40vh",
    overflowY: "auto",
    overflowX: "hidden",
  },
});

const IngredientsForm: React.FC = () => {
  const recipe = useRecipe();
  const { classes } = useStyles();

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={2}
      >
        <Typography fontSize={20} fontWeight={700}>
          Ingredients
        </Typography>
        <Button
          variant="outlined"
          startIcon={<AddIcon fontSize="small" />}
          onClick={recipe.openIngredientSearch}
        >
          Add ingredient
        </Button>
      </Box>
      <Box paddingBottom="16px" />
      <List className={classes.list} disablePadding>
        {recipe.ingredients.map((ingredient, index) => (
          <IngredientsListItem
            key={ingredient.ingredient?.id}
            ingredient={ingredient}
            onRemoveIngredient={() => recipe.removeIngredient(index)}
          />
        ))}
      </List>
      <IngredientSearchPanel />
    </Box>
  );
};

export default observer(IngredientsForm);
